import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import RegionModeSelector from "./RegionModeSelector.tsx";

export default function RegionRedirect() {
  const navigate = useNavigate();
  const { name } = useParams<{ name: string }>();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Leggi preferenza salvata
    const preferred = localStorage.getItem("preferredContentType");

    if (preferred) {
      // ✅ Preferenza trovata → redirect diretto
      console.log("✅ Preferenza trovata:", preferred);
      navigate(`/region/${name}/${preferred}`, { replace: true });
    } else {
      // ❌ Nessuna preferenza → mostra modal di scelta
      console.log("❌ Nessuna preferenza → mostra modal");
      setShowModal(true);
    }
  }, [name, navigate]);

  const handleModeSelect = (mode: "trekkings" | "experiences") => {
    // Salva preferenza
    localStorage.setItem("preferredContentType", mode);
    console.log("💾 Preferenza salvata:", mode);

    // Redirect alla mappa
    navigate(`/region/${name}/${mode}`, { replace: true });
  };

  // Mostra modal di scelta
  if (showModal) {
    return (
      <RegionModeSelector regionName={name || ""} onSelect={handleModeSelect} />
    );
  }

  // Loading durante il redirect
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "18px",
        color: "#666",
      }}
    >
      Caricamento...
    </div>
  );
}
